import * as React from 'react';
import { useState, useEffect } from "react";
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, where, doc, orderBy, limit, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from "firebase/storage";

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
  const firestore = getFirestore(firebaseApp);
  const storage = getStorage(firebaseApp);
  
  /* Identify the current user */
  const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function CarbonMeasurementPage() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [site, setSite] = useState([])
    const [siteType, setSiteType] = useState([])
    const [connection1, setConnection1] = useState(false)
    const [connection2, setConnection2] = useState(false)
    const [connection3, setConnection3] = useState(false)
    const [connection4, setConnection4] = useState(false)
    const [connection5, setConnection5] = useState(false)
    const [connection6, setConnection6] = useState(false)
    const [connection7, setConnection7] = useState(false)
    const [connection8, setConnection8] = useState(false)
    const [name, setName] = useState([])
    const [portfolio, setPortfolio] = useState([])
    const [building, setBuilding] = useState([])
    const [strata, setStrata] = useState([])
    const [siteChoice, setSiteChoice] = useState([])
    const [emptySite, setEmptySite] = useState([])
    const [type, setType] = useState([])
    const [choice, setChoice] = useState([])
    const [emptyFeed, setEmptyFeed] = useState([])
    const [method, setMethod] = useState([])
    const [siteFileId, setSiteFileId] = useState([])
    const [feedFileId, setFeedFileId] = useState([])
    const [fullSite, setFullSite] = useState([])
    const [fullSites, setFullSites] = useState([])
    const [feed, setFeed] = useState([]);
    const [score, setScore] = useState("");
    const [myId, setMyId] = useState([]);
    const [myType, setMyType] = useState([]);
    const [myMethod, setMyMethod] = useState([]);
    const [modify1, setModify1] = useState([]);
    const [modify2, setModify2] = useState([]);
    const [modify3, setModify3] = useState([]);
    const [modify4, setModify4] = useState([]);
    const [modify5, setModify5] = useState([]);
    const [specific, setSpecific] = useState([]);
    const [feedList, setFeedList] = useState([]);

    useEffect(() => {
      const siteQuery = query(
        collection(firestore, 'sites'),
        where('email', '==', user_email),
        orderBy('siteId')
      );
      const unsubscribe = onSnapshot(siteQuery, snapshot => {
        setSite(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
      })
  
      return () => {
        unsubscribe()
      }
    }, [])

    const [ID, setID] = useState();
    useEffect(() => {
        const idQuery = query(
            collection(firestore, 'sites'),
            where('email', '==', user_email),
            limit(1),
            orderBy('siteId', 'desc')
        );
        onSnapshot(idQuery, snapshot => {
            const t = (snapshot.docs.map(doc => ({ id: doc.data().siteId })))
            if (!t[0]) {
                setID('0')
            } else {
                setID(JSON.stringify(t[0].id))
            }
        })
    }, [])

    useEffect(() => {
      const siteQuery = query(
        collection(firestore, 'sites'),
        where('email', '==', user_email),
        where('feedName', '==', ""),
        orderBy('siteId')
      );
      const unsubscribe = onSnapshot(siteQuery, snapshot => {
        setEmptySite(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
      })
  
      return () => {
        unsubscribe()
      }
    }, [])

    useEffect(() => {
      const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email),
        where('siteId', '==', "")
      );
      const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setEmptyFeed(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
      })
  
      return () => {
        unsubscribe()
      }
    }, [])

    useEffect(() => {
      const siteQuery = query(
        collection(firestore, 'sites'),
        where('email', '==', user_email),
        where('siteId', '==', Number(siteChoice))
      );
      const unsubscribe = onSnapshot(siteQuery, snapshot => {
        setSiteFileId(snapshot.docs.map(doc => ({id: doc.id})))
        setSpecific(snapshot.docs.map(doc => ({id: doc.id, data: doc.data()})))
      })
  
      return () => {
        unsubscribe()
      }
    }, [siteChoice])

    useEffect(() => {
      const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email),
        where('id', '==', Number(choice))
      );
      const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setFeedFileId(snapshot.docs.map(doc => ({id: doc.id, name: doc.data().name})))
      })
  
      return () => {
        unsubscribe()
      }
    }, [choice])

    useEffect(() => {
      const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email)
      );
      const unsubscribe = onSnapshot(connectorQuery, snapshot => {
        setFeedList(snapshot.docs.map(doc => ({id: doc.id, feedid: doc.data().id})))
      })
  
      return () => {
        unsubscribe()
      }
    }, [])

    useEffect(() => {
      const siteQuery = query(
        collection(firestore, 'sites'),
        where('email', '==', user_email),
        where('method', '!=', "")
      );
      const unsubscribe = onSnapshot(siteQuery, snapshot => {
        setFullSites(snapshot.docs.map(doc => ({id: doc.id, data: doc.data()})))
      })
  
      return () => {
        unsubscribe()
      }
    }, [])

    useEffect(() => {
      const siteQuery = query(
        collection(firestore, 'sites'),
        where('email', '==', user_email),
        where('name', '==', fullSite)
      );
      const unsubscribe = onSnapshot(siteQuery, snapshot => {
        setMyId(snapshot.docs.map(doc => (doc.data().feedId)))
        setMyType(snapshot.docs.map(doc => (doc.data().type)))
        setMyMethod(snapshot.docs.map(doc => (doc.data().method)))
      })

      return () => {
        unsubscribe()
      }
    }, [fullSite])

    useEffect(() => {
      const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email),
        where('id', '==', Number(myId[0]))
      );
        const unsubscribe = onSnapshot(connectorQuery, snapshot => {
          setFeed(snapshot.docs.map(doc => ({file: doc.data().file })))
        })

        return () => {
          unsubscribe()
        }
  }, [myId])

    const handleAdd = () => {
      setConnection1(true)
    }

    function formatDate() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
  
      return [year, month, day].join('-');
    }

    const closeRequest1 = () => {
      setConnection1(false)
      setSiteType([])
    }

    const handleNext1 = () => {
      if (siteType == '') {
        alert("Please choose one")
      } else {
        if (siteType == 'N') {
          setConnection2(true)
          closeRequest1()
        } else {
          setConnection3(true)
          closeRequest1()
        }
      }
    }

    const closeRequest2 = () => {
      setConnection2(false)
      setName([])
      setPortfolio([])
      setBuilding([])
      setStrata([])
    }

    function handleSubmit() {
      if (name == '' || portfolio == '' || building == '' || strata == '') {
        alert("Please fill in all the info!")
      } else {
        const CollectionRef = collection(firestore, 'sites')
        const date1 = new Date()
        const siteId = Number(ID) + 1

        addDoc(CollectionRef, {siteId, date: date1, name, portfolio, building, strata, email: user_email, feedId: '', feedName: '', type: '', method: ''})
        .then(response => {
            console.log(response.id)
            const fileId = response.id
            alert("Add successfully!")
        })
        .catch(error => {
            console.log(error.message)
            alert(error.message)
        })

        const email = user_email
        const content = "Created a new site : " + name
        const date2 = formatDate()
        const time = new Date()
        addDoc(collection(firestore, 'alerts'), {email, content, date: date2, time})
        closeRequest2()
      }
    }

    const closeRequest3 = () => {
      setConnection3(false)
      setSiteChoice([])
    }

    const handleNext2 = () => {
      if (siteChoice == '') {
        alert("Please choose one")
      } else {
        setConnection3(false)
        setConnection4(true)
      }
    }

    const closeRequest4 = () => {
      setConnection4(false)
      setChoice([])
      setType([])
      setSiteChoice([])
    }

    const handleNext3 = () => {
      if (choice == '' || type == '') {
        alert("Please choose one")
      } else {
        setConnection4(false)
        setConnection5(true)
      }
    }

    const closeRequest5 = () => {
      setConnection5(false)
      setMethod([])
      setChoice([])
      setType([])
      setSiteChoice([])
    }

    function handleFinal() {
      if (method == '') {
        alert("Please choose one of the methodologies that you would like to apply on your current feed.")
        return 
      }

      if (feedFileId[0].id && siteFileId[0].id) {
        updateDoc(doc(firestore, 'sites/'+siteFileId[0].id), {feedId: Number(choice), feedName: feedFileId[0].name, method, type})
        .then(() => {
          alert("Updated!")
          updateDoc(doc(firestore, 'connectors/'+feedFileId[0].id), {siteId: Number(siteChoice)})
          .then(() => {closeRequest5()})
        })
        .catch((error) => {
            console.log(error.message)
            alert(error.message)
        });
      } else {
        alert("Something is wrong. Please try again.")
      }
    }

    function handleFeed() {
      if (fullSite == "") {
        alert("Please select a valid site!")
        return 
      }

      const filename = feed[0].file
      getDownloadURL(ref(storage, user_email + '/' + filename))
      .then((url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
          handleFile(blob)
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
      });
  }

  function handleFile(file) {
      const reader = new FileReader()

      reader.onload = function (e) {
        const text = e.target.result;
        var Data = csvToArray(text);
        Data.pop()
          if (myType == "BIM") {
              calculation1(Data)
          } else {
              calculation2(Data)
          }
      };

      reader.readAsText(file)
  }

  function csvToArray(str, delimiter = ",") {
      const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
          object[header] = values[index];
          return object;
        }, {});
        return el;
      });

      return arr
  }

  function calculation1(data) {
      const amount = data.length
      const keys = Object.keys(data[0]).length
      const res = amount / 400 * 70 + keys / 20 * 30
      setScore(res.toFixed(2))
  }

  function calculation2(data) {
      const standard = 5000.0

      const amount = data.length
      var sum = 0.0
      data.forEach((elem) => {
        var tmp = elem
        delete tmp["Date/Time"]
        Object.values(tmp).forEach((num) => {
          sum = sum + parseFloat(num)
        })
      })
      const average = sum / amount
      const res = average / standard * 100
      setScore(res.toFixed(2))
  }

  const closeRequest6 = () => {
    setConnection6(false)
    setSiteChoice([])
  }

  const handleNext4 = () => {
    if (siteChoice == '') {
      alert("Please choose one")
    } else {
      setModify1(specific[0].data.name)
      setModify2(specific[0].data.portfolio)
      setModify3(specific[0].data.building)
      setModify4(specific[0].data.strata)
      setModify5(specific[0].data.type)
      setConnection6(false)
      setConnection7(true)
    }
  }

  const closeRequest7 = () => {
    setConnection7(false)
    setSiteChoice([])
  }

  function handleModify() {
    if (modify1 == '' || modify2 == '' || modify3 == '' || modify4 == '' || modify5 == '') {
      alert("Some value is empty!")
    } else {
        if (window.confirm("Are you sure that you want to modify the information? They will cover the previous records.")) {
            updateDoc(doc(firestore, 'sites/'+siteFileId[0].id), {name: modify1, portfolio: modify2, building: modify3, strata: modify4, type: modify5})
            .then(() => {
                alert("Updated!")
                closeRequest7()
            })
            .catch((error) => {
                console.log(error.message)
                alert(error.message)
            });
        }
    }
  }

  const closeRequest8 = () => {
    setConnection8(false)
    setSiteChoice([])
  }

  function handleDelete() {
    if (window.confirm("Are you sure that you want to modify the information? They will cover the previous records.")) {
      if (specific[0].data.feedId == "") {
        deleteDoc(doc(firestore, "sites", siteFileId[0].id))
      } else {
        deleteDoc(doc(firestore, "sites", siteFileId[0].id))
        var feedfileid = ""
        feedList.forEach((row) => {
          if (row.feedid == specific[0].data.feedId) {
            feedfileid = row.id
          }
        })
        updateDoc(doc(firestore, 'connectors/'+feedfileid), {siteId: ""})
      }
      closeRequest8()
    }
  }

    return (
        <Box sx={{ display: 'flex', height: '100%'}}>
            {/* Side bar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                        {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>

                <Divider />

                {/* Navigations to different pages */}
                <List component="nav">
                    <ListItemButton href="/Dashboard/Carbon" >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Carbon Calculation" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Carbon/Reporting" >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Carbon Reporting" />
                    </ListItemButton>
                </List>
            </Drawer>

            <Box sx={{ width: '100%' }}>
                <Box sx={{ width: '90%' }}>
                    {/* Title */}
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Carbon Measurement / Calculation
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Carbon Calculation
                    </Typography>
                </Box>

                <Box sx={{ ml: 8.5, mt: 3, display: 'flex' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        >
                        Add a new site of your business: 
                    </Typography>
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ ml: 2, mt: -0.5, borderRadius: 5 }}
                        position="absolute"
                        onClick={handleAdd}
                    >
                        Add
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 2, mt: -0.5, borderRadius: 5 }}
                        position="absolute"
                        onClick={() => {setConnection6(!connection6)}}
                    >
                        Modify
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ ml: 2, mt: -0.5, borderRadius: 5 }}
                        position="absolute"
                        onClick={() => {setConnection8(!connection8)}}
                    >
                        Delete
                    </Button>
                </Box>

                <Box sx={{ ml: 8, mt: 1 }}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 800 }} aria-label="site table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="right">ID</TableCell>
                          <TableCell align="right">Name</TableCell>
                          <TableCell align="right">Date</TableCell>
                          <TableCell align="right">Portfolio</TableCell>
                          <TableCell align="right">Building</TableCell>
                          <TableCell align="right">Strata</TableCell>
                          <TableCell align="right">Feed</TableCell>
                          <TableCell align="right">Feed ID</TableCell>
                          <TableCell align="right">Data Type</TableCell>
                          <TableCell align="right">methodology</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {site?.map((row) => (
                          <TableRow
                            key={row.data.siteId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              {row.data.siteId}
                            </TableCell>
                            <TableCell align="right">{row.data.name}</TableCell>
                            <TableCell align="right">{row.data.date.toDate().toString()}</TableCell>
                            <TableCell align="right">{row.data.portfolio}</TableCell>
                            <TableCell align="right">{row.data.building}</TableCell>
                            <TableCell align="right">{row.data.strata}</TableCell>
                            <TableCell align="right">{row.data.feedName}</TableCell>
                            <TableCell align="right">{row.data.feedId}</TableCell>
                            <TableCell align="right">{row.data.type}</TableCell>
                            <TableCell align="right">{row.data.method}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Box sx={{ ml: 8.5, mt: 3, display: 'flex' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ mt: 1, mr: 2 }}
                        >
                        Apply the methodology and see the result: 
                    </Typography>

                    <FormControl sx={{minWidth: 200 }} variant= "standard">
                      <Select native defaultValue="" label="Feed" disableUnderline
                          theme={theme}
                          sx={{
                              borderRadius: 25,
                              backgroundColor: theme.palette.background.default,
                              padding: "6px 15px",
                          }}
                          value={fullSite}
                          onChange={(e) => {setFullSite(e.target.value)}}>
                          
                          <option aria-label="None" value="">Your site</option>
                          {fullSites?.map((row) => (
                              <option value={row.data.name}>{row.data.name}</option>
                          ))}
                      </Select>
                  </FormControl>

                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ ml: 3, borderRadius: 5 }}
                        position="absolute"
                        onClick={handleFeed}
                    >
                        Run
                    </Button>
                </Box>

                <Box>
                    {score &&
                        <Typography variant="h6" color='#32CD32' sx={{ ml: 8, mt: 6 }}>The outcome is: {score}</Typography>
                    }
                </Box>

                <Dialog open={connection1} onClose={closeRequest1} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step1</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please select your type of site:
                        </DialogContentText>
                        
                        <Box sx={{ display: "flex", mt: 3 }}>
                            <RadioGroup row sx={{ ml: 7 }} onChange={(e) => setSiteType(e.target.value)}>
                                <FormControlLabel value="N" control={<Radio />} label="New" />
                                <Box sx={{ width: 150 }} />
                                <FormControlLabel value="E" control={<Radio />} label="Existing site" />
                            </RadioGroup>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest1}>Cancel</Button>
                        <Button onClick={handleNext1}>Next</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection2} onClose={closeRequest2} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step2</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please input the information of your new site:
                        </DialogContentText>
                        
                        <Box>
                          <FormControl sx={{ ml: 8, mt: 3, mb: 3, minWidth: 400 }}>
                            <TextField label="Name" variant="standard" onChange={(e) => {setName(e.target.value)}}/>
                            <TextField label="Portfolio" variant="standard" onChange={(e) => {setPortfolio(e.target.value)}}/>
                            <TextField label="Building" variant="standard" onChange={(e) => {setBuilding(e.target.value)}}/>
                            <TextField label="Strata" variant="standard" onChange={(e) => {setStrata(e.target.value)}}/>
                          </FormControl>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest2}>Cancel</Button>
                        <Button onClick={handleSubmit}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection3} onClose={closeRequest3} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step2</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please select one of your site:
                        </DialogContentText>
                        
                        <Box sx={{ minHeight: 100, ml: 7, mt: 10 }}>
                          <Box sx={{ display: 'flex', mt: 5 }}>
                            <Typography variant="h7">Select your site:</Typography>
                            <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                              <Select native defaultValue="" label="feed" disableUnderline
                                  theme={theme}
                                  sx={{
                                      borderRadius: 25,
                                      backgroundColor: theme.palette.background.default,
                                      padding: "6px 15px",
                                  }}
                                  value={siteChoice}
                                  onChange={(e) => {setSiteChoice(e.target.value)}}>
                                  
                                  <option value="">Your Sites:</option>
                                  {emptySite?.map((row) => (
                                      <option value={row.data.siteId}>{row.data.name}</option>
                                  ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest3}>Cancel</Button>
                        <Button onClick={handleNext2}>Next</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection4} onClose={closeRequest4} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step3</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please map your data feed and format:
                        </DialogContentText>

                        <Box sx={{ display: 'flex' }}>
                          <Typography variant="h7" sx={{ ml: 8, mt: 5 }}>Choose file: </Typography>
                          <FormControl sx={{ ml: 2, mt: 4, minWidth: 200 }} variant= "standard">
                            <Select native label="Select File" disableUnderline onChange={(e) => setChoice(e.target.value)}
                              theme={theme}
                              sx={{
                                  borderRadius: 25,
                                  backgroundColor: theme.palette.background.default,
                                  padding: "6px 15px",
                              }}
                            >
                              <option value=""></option>
                              {emptyFeed?.map((row) => (
                                <option value={row.data.id}>{row.data.name}</option>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                        
                        <Box sx={{ display: "flex", mt: 5 }}>
                            <Typography variant="h7" sx={{ mt: 1, ml: 8 }}>Choose type:</Typography>
                            <RadioGroup row sx={{ ml: 4 }} onChange={(e) => setType(e.target.value)}>
                                <FormControlLabel value="BIM" control={<Radio />} label="BIM" />
                                <FormControlLabel value="Energy" control={<Radio />} label="Energy Utility" />
                            </RadioGroup>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest4}>Cancel</Button>
                        <Button onClick={handleNext3}>Next</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection5} onClose={closeRequest5} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step4</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please select your preferred methodology:
                        </DialogContentText>
                        
                        <Box sx={{ display: "flex", mt: 3 }}>
                            <RadioGroup row sx={{ ml: 7 }} onChange={(e) => setMethod(e.target.value)}>
                                <FormControlLabel value="Calculation1" control={<Radio />} label="Calculation1" />
                                <Box sx={{ width: 150 }} />
                                <FormControlLabel value="Calculation2" control={<Radio />} label="Calculation2" />
                            </RadioGroup>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest5}>Cancel</Button>
                        <Button onClick={handleFinal}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection6} onClose={closeRequest6} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Modify data</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please select one of your site:
                        </DialogContentText>
                        
                        <Box sx={{ minHeight: 100, ml: 7, mt: 10 }}>
                          <Box sx={{ display: 'flex', mt: 5 }}>
                            <Typography variant="h7">Select your site:</Typography>
                            <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                              <Select native defaultValue="" label="feed" disableUnderline
                                  theme={theme}
                                  sx={{
                                      borderRadius: 25,
                                      backgroundColor: theme.palette.background.default,
                                      padding: "6px 15px",
                                  }}
                                  value={siteChoice}
                                  onChange={(e) => {setSiteChoice(e.target.value)}}>
                                  
                                  <option value="">Your Sites:</option>
                                  {site?.map((row) => (
                                      <option value={row.data.siteId}>{row.data.name}</option>
                                  ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest6}>Cancel</Button>
                        <Button onClick={handleNext4}>Next</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection7} onClose={closeRequest7} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Step2</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please input the information of your site:
                        </DialogContentText>
                        
                        {specific?.map((row) => (
                        <div>
                          <Box>
                            <FormControl sx={{ ml: 8, mt: 3, mb: 3, minWidth: 400 }}>
                              <TextField label="Name" variant="standard" defaultValue={row.data.name} onChange={(e) => {setModify1(e.target.value)}}/>
                              <TextField label="Portfolio" variant="standard" defaultValue={row.data.portfolio} onChange={(e) => {setModify2(e.target.value)}}/>
                              <TextField label="Building" variant="standard" defaultValue={row.data.building} onChange={(e) => {setModify3(e.target.value)}}/>
                              <TextField label="Strata" variant="standard" defaultValue={row.data.strata} onChange={(e) => {setModify4(e.target.value)}}/>
                            </FormControl>
                          </Box>

                          <Box sx={{ display: "flex", mt: 5 }}>
                              <Typography variant="h7" sx={{ mt: 1, ml: 8 }}>Choose type:</Typography>
                              <RadioGroup row sx={{ ml: 4 }} onChange={(e) => setModify5(e.target.value)}>
                                  <FormControlLabel value="BIM" control={<Radio />} label="BIM" />
                                  <FormControlLabel value="Energy" control={<Radio />} label="Energy Utility" />
                              </RadioGroup>
                          </Box>
                        </div>
                        ))}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest7}>Cancel</Button>
                        <Button onClick={handleModify}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={connection8} onClose={closeRequest8} maxWidth={"sm"} fullWidth={true}>
                    <DialogTitle>Delete site</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please select one of your site:
                        </DialogContentText>
                        
                        <Box sx={{ minHeight: 100, ml: 7, mt: 10 }}>
                          <Box sx={{ display: 'flex', mt: 5 }}>
                            <Typography variant="h7">Select your site:</Typography>
                            <FormControl variant= "standard" sx={{ ml: 3, mt: -1 }}>
                              <Select native defaultValue="" label="feed" disableUnderline
                                  theme={theme}
                                  sx={{
                                      borderRadius: 25,
                                      backgroundColor: theme.palette.background.default,
                                      padding: "6px 15px",
                                  }}
                                  value={siteChoice}
                                  onChange={(e) => {setSiteChoice(e.target.value)}}>
                                  
                                  <option value="">Your Sites:</option>
                                  {site?.map((row) => (
                                      <option value={row.data.siteId}>{row.data.name}</option>
                                  ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeRequest8}>Cancel</Button>
                        <Button onClick={handleDelete}>confirm</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    )
}